<div class="pt-8 min-w-0 max-w-full">
    <div class="flex justify-center">
        <fa-icon
            class="text-on-surface shrink-0"
            size="2x"
            [icon]="['fas', 'warning']" />
    </div>

    <p class="text-sm font-normal text-custom-extra-dark-grey pt-3 text-left break-words">
        {{ (deposit().standard ? 'errorStandardDeposit' : 'errorValidityDeposit') | transloco }}
    </p>
</div>

<div class="gap-8 flex flex-col pb-4 min-w-0 max-w-full">
    @if (tableErrors().length) {
        <app-deposit-validation-error-list
            title="missingTable"
            [dataToDisplay]="tableErrors()" />
    }

    @if (columnErrors().length) {
        <app-deposit-validation-error-list
            title="missingColumn"
            [dataToDisplay]="columnErrors()" />
    }

    @if (tableDuplicates().length) {
        <app-deposit-validation-error-list
            title="duplicateLayer"
            [dataToDisplay]="tableDuplicates()" />
    }
</div>

@if (deposit().status === Deposit.StatusEnum.FAILED) {
    <div
        class="bg-custom-orange-container p-4 text-on-custom-orange-container text-center break-words"
        role="alert">
        <p class="font-bold">
            {{ 'validationFailedWarning' | transloco }}
        </p>

        @if (!tableDuplicates().length) {
            <button
                mat-stroked-button
                (click)="relaunch.emit()">
                <span class="text-on-custom-orange-container">
                    {{ 'validateAgain' | transloco }}
                </span>
            </button>
        }
    </div>
}
